
export enum ScheduleStatusCd {
	DELAYED = 'Delayed',
	ENROUTE = 'Enroute',
	HELD = 'Held',
	NOT_APPLICABLE = 'NotApplicable'}

